<template>
  <div>
    <CRow>
      <CCol col="12" lg="12">
        <CCard>
          <CCardBody>
            <AppForm 
              :key="appFormKey"
              :vo-name="isEdit ? 'BoMemberGetVo' : 'BoMemberAddVo'"
              :data="tmpBoMember" 
              @changed="onFormChange"
            />
          </CCardBody>
          <CCardFooter>
            <LoadingStateButton
              @click="onAddOrUpdateBoMember"
              :text="i18nMessage.Apply"
              color="primary"
              :loading="updateBoMemberLoading"
            />
            <template v-if="isEdit">
              &nbsp;
              <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
            </template>
            &nbsp;
            <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
        :show.sync="showDeleteModal"
        :centered="true"
        color="default"
      >
        {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{boMember.username}}</b>
        <br/><br/>
        <CInput
            :placeholder="i18nMessage.PleaseInputText"
            v-model="deleteConfirmText"
          />
        <template #header>
          <span class="modal-title">{{i18nMessage.Delete}}？</span>
          <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
        </template>
        <template #footer>
          <LoadingStateButton
            :disabled="deleteConfirmText !== boMember.username"
            @click="onDeleteBoMember"
            :text="i18nMessage.Apply"
            color="danger"
            :loading="deleteBoMemberLoading"
          />
          <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
        </template>
      </CModal>
  </div>
</template>

<style>
</style>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID, isEmpty } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'BoMember',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpBoMember: {},
      updateBoMemberLoading: false,
      deleteBoMemberLoading: false,
      appFormKey: generateGUID(),
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      boMember: state => state.boMember.boMember,
    }),
  },
  methods: {
    ...mapActions({
      getBoMember: 'boMember/getBoMember',
      addBoMember: 'boMember/addBoMember',
      updateBoMember: 'boMember/updateBoMember',
      deleteBoMember: 'boMember/deleteBoMember',
    }),
    ...mapMutations({
      setBoMember: 'boMember/setBoMember',
    }),
    goBack() {
      this.$router.push({path: '/bo-member'})
    },
    onEditorContentChange (template, style) {
      this.tmpBoMember = {
        ...this.tmpBoMember,
        template,
        style,
      }
    },
    onFormChange (data) {
      this.tmpBoMember = {...data}
    },
    onDeleteBoMember () {
      this.deleteBoMemberLoading = true
      this.deleteBoMember(this.boMember.id)
          .then(() => {
            this.deleteBoMemberLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteBoMemberLoading = false
            this.showDeleteModal = false
          })
    },
    onAddOrUpdateBoMember () {
      if (isEmpty(this.tmpBoMember)) {
        return
      }
      if (this.tmpBoMember.id) {
        this.updateBoMemberLoading = true
        this.updateBoMember(this.tmpBoMember)
          .then(() => {
            this.updateBoMemberLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateBoMemberLoading = false
          })
      } else {
        this.updateBoMemberLoading = true
        this.addBoMember(this.tmpBoMember)
          .then(() => {
            this.updateBoMemberLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateBoMemberLoading = false
          })
      }
    },
  },
  mounted() {
    if (this.isEdit) {
      this.getBoMember(this.$route.params.id).then(() => {
        this.tmpBoMember = this.boMember
      })
    }
  },
  destroyed() {
    this.setBoMember({})
  }
}
</script>
